import React from "react";
import TableComponent from "../common/TableComponent";
import {
  bohEquipment,
  cableEqipment,
  gasHandlingintakeEquipment,
  mleEquipment,
  MotorEquipment,
  protectorEquipment,
  pumpEquipment,
  sensorEquipment,
  belowESPEquipment,
  tailPipeEquipment,
  miscellaneousReportColumns,
  aboveESPEquipment,
  gasSeparatorintakeEquipment,
  emptyEquipmentData,
} from "../../constants/columns/calculations/schematics";
import { useAppSelector } from "../../store/hooks/StoreHooks";
import { EquipmentType } from "../../store/model/calculations/schematics";

interface ISizingSchematic {
  ReportData?: any;
}

const EMPTY_MOTOR_PERFORMANCE: Record<string, never> = {};

const SizingSchematic: React.FC<ISizingSchematic> = (ReportData: any) => {
  const schematicsData = useAppSelector(
    (state) => state?.calculations?.schematicData
  );
  const { intakeMD } = useAppSelector((state) => state?.calculations);
  const { ESPEquipmentsForBelow, ESPEquipmentsForAbove } = useAppSelector(
    (state) => state?.schematic
  );
  const motorPerformance = useAppSelector(
    (state) => state?.motor?.MotorperformanceList?.[0] ?? EMPTY_MOTOR_PERFORMANCE
  );
  const updateEquipmentsAboveESP = ESPEquipmentsForAbove && ESPEquipmentsForAbove?.filter((item) => Object?.keys(item)?.length > 0);
  const updateEquipmentsBelowESP = ESPEquipmentsForBelow && ESPEquipmentsForBelow?.filter((item) => Object?.keys(item)?.length > 0);
  const sensorList = schematicsData?.equipmentsList.filter(
    (x) => x.equipmentType == EquipmentType.SRSensor
  );
  const updateSensorList = sensorList && sensorList?.filter((x) => Object?.keys(x)?.length > 0);
  const cableList = schematicsData?.equipmentsList.filter(
    (x) => x.equipmentType == EquipmentType.SRCables
  );  
  const protectorList = schematicsData?.equipmentsList.filter(
    (x) => x.equipmentType == EquipmentType.SRProtectors
  );
  const updateProtectorList = protectorList
  ?.filter((x) => Object.keys(x)?.length > 0)
  ?.sort((a, b) => a.displayOrder - b.displayOrder);
  const cableLength = updateProtectorList?.length === 2 ? updateProtectorList?.[1]?.setDepth : (updateProtectorList?.length === 1 && updateProtectorList?.[0]?.equipments === "0") ? updateProtectorList?.[0]?.setDepth : intakeMD;
  const updateCableList = cableList && cableList?.filter((x) => Object?.keys(x)?.length > 0)?.map((item) => ({
    ...item,
    length: cableLength,
    totalLength: cableLength,
  }));
  const pumpList = schematicsData?.equipmentsList.filter(
    (x) => x.equipmentType == EquipmentType.SRPumps
  );
  const updatePumpList = pumpList && pumpList?.filter((x) => Object?.keys(x)?.length > 0);
  const chargePumpList1 = schematicsData?.equipmentsList.filter(
    (x) => x.equipmentType == EquipmentType.SRChargePump1
  );
  const updatedChargePumpList1 = chargePumpList1 && chargePumpList1?.filter((x) => Object?.keys(x)?.length > 0);
  const chargePumpList2 = schematicsData?.equipmentsList.filter(
    (x) => x.equipmentType == EquipmentType.SRChargePump2
  );
  const updatedChargePumpList2 = chargePumpList2 && chargePumpList2?.filter((x) => Object?.keys(x)?.length > 0);
  const chargePumpList3 = schematicsData?.equipmentsList.filter(
    (x) => x.equipmentType == EquipmentType.SRChargePump3
  );
  const updatedChargePumpList3 = chargePumpList3 && chargePumpList3?.filter((x) => Object?.keys(x)?.length > 0);

  const bohList = schematicsData?.equipmentsList.filter(
    (x) => x.equipmentType == EquipmentType.SRBOH
  );
  const updateBohList= bohList && bohList?.filter((x) => Object?.keys(x)?.length > 0);
  const updateAllPumpList=[...(updatePumpList ?? []), ...(updatedChargePumpList3 ?? []), ...(updatedChargePumpList2 ?? []), ...(updatedChargePumpList1 ?? [])];

  const gasSeparatorList = schematicsData?.equipmentsList.filter(
    (x) => x.equipmentType == EquipmentType.SRGasSeparators
  );
  const updateGasSeparatorList = gasSeparatorList && gasSeparatorList?.filter((x) => Object?.keys(x)?.length > 0);
  const gasHandlerList = schematicsData?.equipmentsList.filter(
    (x) => x.equipmentType == EquipmentType.SRGasHandlers
  );
  const updateGasHandlerList = gasHandlerList && gasHandlerList?.filter((item) => Object?.keys(item)?.length > 0);
  const mleList = schematicsData?.equipmentsList.filter(
    (x) => x.equipmentType == EquipmentType.SRMLE
  );
  const updatedMleList = mleList && mleList?.filter((item) => Object?.keys(item)?.length > 0);
  const motorList = schematicsData?.equipmentsList.filter(
    (x) => x.equipmentType == EquipmentType.SRMotors
  );
  const updatedMotorList = motorList && motorList?.filter((item) => Object?.keys(item)?.length > 0);
  const miscellaneousList = schematicsData?.miscellaneous?.miscList;
  const espAboveESPList = schematicsData?.equipmentsList.filter(
    (x) => x.equipmentType == EquipmentType.SRAccAboveESP
  );
  const { tab1Input } = useAppSelector((state) => state?.tubing);
  const TailPipe = schematicsData?.miscellaneous;
  var miscList = [
    {
      tailPipeJoints: TailPipe?.tailPipeJoints ?? 0,
      length: Number(TailPipe?.tailPipeJoints ?? 0) * 31.7,
      weight: (Number(TailPipe?.tailPipeJoints) * 31.7 * tab1Input?.tubingWeight)?.toFixed(2) || "",
      diameter: TailPipe?.tailPipeDiameter ?? "",
      setDepth: TailPipe?.tailPipeSetDepth ?? "",
    },
  ];

  return (
    <>
      {schematicsData?.miscellaneous?.showSchematicData && (
        <div className=''>
          <div className='determine-widget-containers mb-5 mt-5'>
            <div className="header-main">
              <div className="flex flex-row justify-between">
                <div>
                  <p className="text-[18px] font-semibold text-neutral-25">DETERMINE schematic summary</p>
                  <h5>Projected performance for the ESP design.</h5>
                </div>
              </div>
            </div>
            <div className='border-y-[1px] border-dark flex flex-col gap-2 py-[20px] px-[24px]'>
              <div className='flex flex-col gap-2'>
                <p className='text-[16px] text-primary-400 font-bold pb-5 row-bottom-line'>Recommended parameters</p>
                <table>
                  <tr>
                    <td>EO tubing</td><td>{ReportData?.ReportData?.TopOfEspPump + ' ft'}</td>
                    <td>Startup freq</td><td>{ReportData?.ReportData?.SR_StartUpFreq + ' Hz'}</td>
                    <td>ESP btm depth</td><td>{ReportData?.ReportData?.BottomOfEspSensor + ' ft'}</td>
                  </tr>
                  <tr>
                    <td>Intake set depth</td><td>{ReportData?.ReportData?.SR_GasSeperator1SetDepth + ' ft'}</td>
                    <td>Min freq at departure</td><td>{ReportData?.ReportData?.SR_MinFreqatDeparture + ' Hz'}</td>
                    <td>Set depth</td><td>{ReportData?.ReportData?.SR_TailPipeSetDepth + ' ft'}</td>
                  </tr>
                  <tr>
                    <td>Required surface power</td><td>{ReportData?.ReportData?.Surface_KVARequired} {ReportData?.ReportData?.Surface_KVARequired_Unit}</td>
                    <td>Max freq</td><td>{ReportData?.ReportData?.SR_MaxFrequency + ' Hz'}</td>
                    <td>KOP</td><td>{ReportData?.ReportData?.KOP + ' ft'}</td>
                  </tr>
                  <tr>
                    <td>Design frequency</td><td>{ReportData?.ReportData?.OperatingFrequency + ' Hz'}</td>
                    <td>Surf.Volts @ {ReportData?.ReportData?.SR_MaxFrequency} Hz</td><td>{ReportData?.ReportData?.SR_SurfVolts + ' volts'}</td>
                    <td>ESP length</td><td>{ReportData?.ReportData?.EspLength + ' ft'}</td>
                  </tr>
                  <tr>
                    <td>Casing size (in)</td><td>{ReportData?.ReportData?.Casing}</td>
                    <td>ESP + Desander + Tail Pipe</td><td>{ReportData?.ReportData?.SR_ESPTailPipeDesanderLength + ' ft'}</td>
                    <td>Downhole ESP weight</td><td>{ReportData?.ReportData?.SR_DownholeESPWeight + ' lb'}</td>
                  </tr>
                  <tr>
                    <td>Tubing size (in)</td><td>{ReportData?.ReportData?.Tubing}</td>
                    <td>Target production</td><td>{ReportData?.ReportData?.ProductionRate} {ReportData?.ReportData?.ProductionRate_Unit}</td>
                    <td>MLE length for splice</td><td>{ReportData?.ReportData?.SR_MLELengthSplice + ' ft'}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div className='border-dark flex flex-col gap-2 py-[20px] px-[24px]'>
              <div className='flex flex-col gap-2 row-bottom-line'>
                <p className='text-[16px] text-primary-400 font-bold pb-5'>Surface equipment</p>
              </div>
              <div className='noborder'>
                <div className='flex gap-4'>
                  <div>VSD drive:</div>
                  <div>{ReportData?.ReportData?.SR_VSDDrive || ""} {`${ReportData?.ReportData?.SR_VSDDrivePN ? `(PN: ${ReportData?.ReportData?.SR_VSDDrivePN})` : ""}`}</div>
                </div>
                <div className='flex gap-4'>
                  <div>Transformer:</div>
                  <div>{ReportData?.ReportData?.SR_Transformer || ""}</div>
                </div>
                <div className='flex gap-4'>
                  <div>Harmonic filter:</div>
                  <div>{ReportData?.ReportData?.HarmonicFilterSelection} {`${ReportData?.ReportData?.SR_HarmonicFilterPN? `(PN: ${ReportData?.ReportData?.SR_HarmonicFilterPN})` : ""}`}</div>
                </div>
              </div>
            </div>
            <div className='border-t border-dark flex flex-col gap-2 py-[20px] px-[24px]'>
              <div className='flex flex-col gap-2 row-bottom-line'>
                <p className='text-[16px] text-primary-400 font-bold pb-5'>Accessories above ESP</p>
              </div>
              <div className='row-bottom-line flex flex-col'>
                <div className='noborder'>
                  <TableComponent
                    data={updateEquipmentsAboveESP && updateEquipmentsAboveESP?.length > 0 ? updateEquipmentsAboveESP : emptyEquipmentData}
                    columns={[...aboveESPEquipment]}
                    rowsPerPage={1}
                    overFlowClass='noborder'
                  />
                </div>
              </div>
            </div>

            <div className='flex flex-col gap-2 pb-[20px] px-[24px]'>
              <div className='flex flex-col gap-2 row-bottom-line pb-4 mb-5'>
                <p className='text-[16px] font-bold text-primary-400'>ESP equipment</p>
              </div>
              <div className='row-bottom-line flex flex-col mb-5'>
                <div className='noborder flex flex-col gap-[20px]'>
                  <TableComponent
                    data={updateCableList && updateCableList?.length > 0 ? updateCableList : emptyEquipmentData}
                    columns={[...cableEqipment]}
                    rowsPerPage={1}
                    overFlowClass='noborder'
                  />
                  <TableComponent
                    data={updatedMleList && updatedMleList?.length > 0 ? updatedMleList : emptyEquipmentData}
                    columns={[...mleEquipment]}
                    rowsPerPage={1}
                    overFlowClass='noborder'
                  />
                </div>
              </div>
              <div className='noborder row-bottom-line pb-4 mb-5'>
                <TableComponent
                  data={updateBohList && updateBohList?.length > 0 ? updateBohList : emptyEquipmentData}
                  columns={[...bohEquipment]}
                  rowsPerPage={1}
                />
              </div>

              <div className='noborder row-bottom-line pb-4 mb-5'>
                <TableComponent
                  data={updateAllPumpList && updateAllPumpList?.length > 0 ? updateAllPumpList : emptyEquipmentData}
                  columns={[...pumpEquipment]}
                  rowsPerPage={1}
                />
              </div>

              <div className='noborder row-bottom-line pb-4 mb-5'>
                <TableComponent
                  data={updateGasHandlerList && updateGasHandlerList?.length > 0 ? updateGasHandlerList : emptyEquipmentData}
                  columns={[...gasHandlingintakeEquipment]}
                  rowsPerPage={1}
                />
              </div>

              <div className='noborder row-bottom-line pb-4 mb-5'>
                <TableComponent
                  data={updateGasSeparatorList && updateGasSeparatorList?.length > 0 ? updateGasSeparatorList : emptyEquipmentData}
                  columns={[...gasSeparatorintakeEquipment]}
                  rowsPerPage={1}
                />
              </div>

              <div className='noborder row-bottom-line pb-4 mb-5'>
                <TableComponent
                  data={updateProtectorList && updateProtectorList?.length > 0 ? updateProtectorList : emptyEquipmentData}
                  columns={[...protectorEquipment]}
                  rowsPerPage={1}
                />
              </div>
              <div className='noborder row-bottom-line pb-4 mb-5'>
                <TableComponent
                  data={updatedMotorList && updatedMotorList?.length > 0 ? updatedMotorList : emptyEquipmentData}
                  columns={[...MotorEquipment(motorPerformance)]}
                  rowsPerPage={1}
                />
              </div>
              <div className='noborder row-bottom-line pb-4 mb-5'>
                <TableComponent
                  data={updateSensorList && updateSensorList?.length > 0 ? updateSensorList : emptyEquipmentData}
                  columns={[...sensorEquipment]}
                  rowsPerPage={1}
                />
              </div>

              <div className='noborder row-bottom-line pb-4 mb-5"'>
                <div className='pb-2 mb-2'>
                  <p className='text-[16px] text-primary-400 font-bold'>Accessories below ESP</p>
                </div>
                <TableComponent
                  data={updateEquipmentsBelowESP && updateEquipmentsBelowESP?.length > 0 ? updateEquipmentsBelowESP : emptyEquipmentData}
                  columns={[...belowESPEquipment]}
                  rowsPerPage={1}
                />
              </div>

              <div className='noborder row-bottom-line pb-4 mb-5'>
                <TableComponent
                  data={miscList || []}
                  columns={[...tailPipeEquipment]}
                  rowsPerPage={1}
                />
              </div>

              <div className='noborder row-bottom-line pb-4 mb-5"'>
                <div className='pb-2 mb-2'>
                  <p className='text-[16px] text-primary-400 font-bold'>Miscellaneous</p>
                </div>
                <TableComponent
                  data={miscellaneousList && miscellaneousList?.length > 0 ? miscellaneousList : emptyEquipmentData}
                  columns={[...miscellaneousReportColumns]}
                  rowsPerPage={1}
                />
              </div>
              <div className='noborder pb-4 mb-5"'>
                <div className='pb-2 mb-2'>
                  <p className='text-[14px] text-neutral-25 font-semibold'>Notes</p>
                </div>
                <div>{schematicsData?.miscellaneous?.note}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SizingSchematic;
